import { indent, outdent } from "@progress/kendo-editor-common";
import { ProseMirror } from "@progress/kendo-react-editor";
import { icon, label, paletteSettings } from "../../config/constants";

/**
 * Function to create keymap for handling keyboard shortcuts.
 * @param {ProseMirror} ProseMirror - The ProseMirror instance.
 * @param {Function} indent - The function to handle indentation.
 * @param {Function} outdent - The function to handle outdentation.
 * @returns {Keymap} - Returns keymap for handling keyboard shortcuts.
 */
export const keyMapSettings = (taskKey, setShowDialog) => {
  return ProseMirror.keymap({
    Tab: (state, dispatch, view) => {
      indent(state, dispatch, view);
      return true;
    },
    "Shift-Tab": (state, dispatch, view) => {
      outdent(state, dispatch, view);
      return true;
    },
    "Mod-f": () => {
      if (taskKey === label.DOX_TASK_KEY) {
        setShowDialog({ find: true, replace: false });
      }
      return true;
    },
    "Mod-h": () => {
      if (taskKey === label.DOX_TASK_KEY) {
        setShowDialog({ find: true, replace: true });
      }
      return true;
    },
  });
};
